'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { BackendAuth } from '@/lib/auth-backend';

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Prüfe Authentication
        if (!BackendAuth.isAuthenticated()) {
          router.push('/signin');
          return;
        }

        // Lade Domain-spezifische Konfiguration
        const domainInfo = await BackendAuth.apiCallJson('/api/domain/info');
        
        if (domainInfo?.welcome_redirect_to) {
          // Domain-spezifische Weiterleitung — robuste Path-Normalisierung:
          // - Bereits absolute https://...-URLs werden 1:1 verwendet
          // - Bereits-fuehrender Slash wird NICHT verdoppelt (sonst //kaie/...
          //   = protocol-relative URL und Browser sieht 'kaie' als Hostname!)
          const raw = String(domainInfo.welcome_redirect_to).trim();
          if (/^https?:\/\//i.test(raw)) {
            window.location.href = raw;
          } else {
            const path = raw.startsWith('/') ? raw : `/${raw}`;
            router.push(path);
          }
        } else {
          // Standard Dashboard Fallback
          router.push('/dashboard');
        }
      } catch (error) {
        console.error('Domain redirect error:', error);
        router.push('/dashboard'); // Fallback
      }
    };

    handleRedirect();
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Weiterleitung...</p>
      </div>
    </div>
  );
}